import { AsyncPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { Breadcrumb, BreadcrumbService } from 'app/layout/common/breadcumb/breadcrumb.service';


@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  standalone: true,
  imports:[NgFor, NgIf]
})
export class BreadcrumbComponent implements OnInit {
  breadcrumbs = signal<Breadcrumb[]>([]);
  private _breadcrumbService = inject(BreadcrumbService);

  ngOnInit(): void {
    this._breadcrumbService.breadcrumbs$.subscribe(this.breadcrumbs.set);
  }

}
